let button = document.querySelector('.burger-container'),
    menu = document.querySelector('nav .header');

if (button && menu) {
    button.addEventListener('click', () => {
        menu.classList.toggle('menu-opened');
    });
}
